import './style.css';
import { LuBuilding2, LuCalendarDays, LuFileCheck2, LuFlag, LuUserRound } from 'react-icons/lu';

const itemIcons = {
  client: LuUserRound,
  stage: LuFlag,
  purpose: LuBuilding2,
  workPurpose: LuFileCheck2,
  type: LuBuilding2,
  year: LuCalendarDays,
};

const ProjectInfoBar = ({ data }) => {
  const items = data?.items || [];
  if (!items.length) {
    return null;
  }

  return (
    <section className="project-info-bar" aria-label={data.ariaLabel || 'Краткая информация о проекте'}>
      <ul className={`project-info-bar__list${items.length === 5 ? ' project-info-bar__list--five' : ''}${data.equalHeight ? ' project-info-bar__list--equal-height' : ''}`}>
        {items.map(({ id, label, value }) => {
          const Icon = itemIcons[id];
          return (
            <li key={id} className="project-info-bar__item">
            <span className="project-info-bar__icon">{Icon ? <Icon /> : null}</span>

            <span className="project-info-bar__copy">
              <strong>{label}</strong>
              <span>{value}</span>
            </span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default ProjectInfoBar;
